import io from 'socket.io-client'

let socket = null

function getToken() {
  return localStorage.getItem('auth_token') || ''
}

function getCurrentNumber() {
  let current = JSON.parse(localStorage.getItem('current') || '{}')
  return current.number || ''
}

function buildQuery() {
  return 'auth_token=' + getToken() + '&number=' + getCurrentNumber()
}

function setupErrorHandling(s) {
  s.on('connect_error', (err) => {
    console.error('[Socket] connection error:', err.message)
    if (err.message && err.message.toLowerCase().includes('auth')) {
      console.warn('[Socket] auth error, reconnecting with fresh token')
      s.disconnect()
      connect()
    }
  })
  s.on('disconnect', (reason) => {
    if (reason !== 'io client disconnect') {
      console.warn('[Socket] disconnected:', reason)
    }
  })
}

function connect() {
  if (socket) {
    socket.removeAllListeners()
    socket.disconnect()
  }
  socket = io(process.env.VUE_APP_RUTA_SOCKET, {
    query: buildQuery(),
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
  })
  setupErrorHandling(socket)
  return socket
}

function ensureConnected() {
  return new Promise((resolve, reject) => {
    if (socket && socket.connected) {
      resolve(socket)
      return
    }
    let s = connect()
    let timeout = setTimeout(() => {
      s.off('connect')
      s.off('connect_error')
      reject(new Error('Socket connection timeout'))
    }, 10000)
    s.on('connect', () => {
      clearTimeout(timeout)
      resolve(s)
    })
    s.on('connect_error', (err) => {
      clearTimeout(timeout)
      reject(err)
    })
  })
}

function emit(event, data) {
  if (socket && socket.connected) {
    socket.emit(event, data)
    return true
  }
  return false
}

function on(event, callback) {
  if (socket) socket.on(event, callback)
}

function off(event, callback) {
  if (socket) socket.off(event, callback)
}

function disconnect() {
  if (socket) {
    socket.removeAllListeners()
    socket.disconnect()
    socket = null
  }
}

function getSocket() {
  return socket
}

export default {
  connect,
  ensureConnected,
  emit,
  on,
  off,
  disconnect,
  getSocket,
}
